export default __webpack_public_path__ + "static/media/staff-ingrid-doyle.2127d17f.jpg";